import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface DialogButton {
  name: string;
  label: string;
  buttonClass: string;
  iconClass?: string;
  disabled?: boolean;
}

@Component({selector: 'app-my-dialog',
  templateUrl: './my-dialog.component.html',
  styleUrls: ['./my-dialog.component.scss'],
  standalone: false,
})
export class MyDialogComponent {
  /** Is dialog visible */
  @Input() visible: boolean;

  /** Is dialog draggable */
  @Input() draggable: boolean;

  /** Is dialog modal */
  @Input() Modal: boolean;

  /** Is dialog modal */
  @Input() modal: boolean = true;

  /** Is dialog closeable */
  @Input() closable: boolean;

  /** Additional style */
  @Input() style: any;

  /** Use custom content */
  @Input() useCustomContent: boolean;

  /** When we want to add another class to the title container */
  @Input() titleAdditionalClass: string | any;

  /** When we want to add another class to the footer container */
  @Input() footerAdditionalClass: string | any;

  /** Dialog content style */
  @Input() contentStyle: any;

  /** Dialog button on click output */
  @Output() dialogButtonOnClick = new EventEmitter<string>();

  /** Dialog title */
  title: string;

  /** Dialog content */
  content: string;

  /** Title icon class */
  titleIconClass: string;

  /** Title container class icon */
  titleContainerIcon: string;

  buttons: DialogButton[] = [];


  open(
    title: string,
    content: string,
    buttons: DialogButton[],
    titleContainerIcon?: string,
    titleIconClass?: string
  ) {
    this.title = title;
    this.content = content;
    this.buttons = buttons;
    this.titleContainerIcon = titleContainerIcon ?? '';
    this.titleIconClass = titleIconClass ?? '';
    this.visible = true;
  }

  /**
   * Dialog button on click
   * @param buttonName
   */
  dialogButtonClick(buttonName: string) {
    this.dialogButtonOnClick.emit(buttonName);
    this.visible = false;
  }
}
